import React from "react";
// Vendor dependencies
import "./Vendor";
// Application Styles
import "./styles/bootstrap.scss";
import "./styles/app.scss";
import "fullcalendar-reactwrapper/dist/css/fullcalendar.min.css";
import "react-datetime/css/react-datetime.css";
import "sweetalert/dist/sweetalert.css";
import "react-select/dist/react-select.css";

import moment from "moment";
import MeetingSubscription from "./subscriptions/MeetingSubscription";
import ReportSubscription from "./subscriptions/ReportSubscription";
import { Redirect, Route, withRouter, Switch } from "react-router-dom";
import BaseHorizontal from "./components/Layout/BaseHorizontal";
import { createRefetchContainer, graphql } from "react-relay";
import NotificationSubscription from "./subscriptions/NotificationSubscription";
import TimetableSubscription from "./subscriptions/TimetableSubscription";
import MessageSubscription from "./subscriptions/MessageSubscription";
import Loading from "./components/Layout/Loading";

const Dashboard = React.lazy(() =>
  import("./components/SingleView/Dashboard/Dashboard")
);
const ReportsQueryComponent = React.lazy(() =>
  import("./components/SingleView/Reports/ReportsQueryComponent")
);
const Absences = React.lazy(() =>
  import("./components/SingleView/Absences/Absences")
);
const Account = React.lazy(() =>
  import("./components/SingleView/Account/Account")
);
const Basics = React.lazy(() =>
  import("./components/SingleView/Basics/Basics")
);
const NotFound = React.lazy(() => import("./components/Pages/NotFound"));
const Error500 = React.lazy(() => import("./components/Pages/Error500"));
const Maintenance = React.lazy(() => import("./components/Pages/Maintenance"));
const ManagementDashboardQuery = React.lazy(() =>
  import("./components/SingleView/Management/ManagementDashboardQuery")
);
const ManagementProjects = React.lazy(() =>
  import("./components/SingleView/Projects/ManagementProjects")
);
const ManagementStaff = React.lazy(() =>
  import("./components/SingleView/ManagementStaff/ManagementStaff")
);
const ManagementAbsences = React.lazy(() =>
  import("./components/SingleView/ManagementAbsences/ManagementAbsences")
);
const ManagementBasics = React.lazy(() =>
  import("./components/SingleView/Basics/ManagementBasics")
);
const ManagementMessages = React.lazy(() =>
  import("./components/SingleView/Messages/ManagementMessages")
);
const ManagementMeetings = React.lazy(() =>
  import("./components/SingleView/Meetings/ManagementMeetings")
);

class Routes extends React.Component {
  constructor(props) {
    super(props);
    this.notificationSubscription = null;
    this.timetableSubscription = null;
    this.messageSubscription = null;
    this.meetingSubscription = null;
    this.reportSubscription = null;
    this.state = {
      date: moment().format("DD-MM-YYYY"),
    };
  }

  checkRefetch = () => {
    if (this.state.date !== moment().format("DD-MM-YYYY")) {
      this.setState({ date: moment().format("DD-MM-YYYY") }, () =>
        this.props.relay.refetch({
          countPending: 4,
          afterPending: null,
          countAccepted: 4,
          afterAccepted: null,
          countRejected: 4,
          afterRejected: null,
          countCancelled: 4,
          afterCancelled: null,
        })
      );
    }
  };

  componentWillMount() {
    window.addEventListener("focus", this.checkRefetch);
    this.notificationSubscription = NotificationSubscription();
    this.timetableSubscription = TimetableSubscription();
    this.messageSubscription = MessageSubscription();
    this.meetingSubscription = MeetingSubscription();
    this.reportSubscription = ReportSubscription();
  }

  componentDidMount() {
    if (this.props.firebase.isLoaded) {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          this.props.firebase.messaging
            .getToken()
            .then((currentToken) => {
              if (currentToken) {
                this.props.firebase.updateUserMessagingToken(currentToken);
              } else {
                console.log(
                  "No Instance ID token available. Request permission to generate one."
                );
              }
            })
            .catch((err) => {
              console.log("An error occurred while retrieving token. ", err);
              // showToken('Error retrieving Instance ID token. ', err);
              // setTokenSentToServer(false);
            });
        } else {
          console.log("Unable to get permission to notify.");
        }
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("focus", this.checkRefetch);
    this.notificationSubscription.dispose();
    this.timetableSubscription.dispose();
    this.messageSubscription.dispose();
    this.meetingSubscription.dispose();
    this.reportSubscription.dispose();
  }

  render() {
    const user = this.props.user;
    if (user) {
      const routes = [
        <Route
          key={0}
          exact
          path="/dashboard"
          component={() => <Dashboard user={user} />}
        />,
        <Route
          key={1}
          exact
          path="/reports"
          component={() => <ReportsQueryComponent user={user} />}
        />,
        <Route
          key={2}
          exact
          path="/absences"
          component={() => <Absences user={user} />}
        />,
        <Route
          key={3}
          exact
          path="/account"
          component={() => <Account user={user} />}
        />,
        <Route
          key={4}
          exact
          path="/basics"
          component={() => <Basics user={user} />}
        />,
        <Route
          key={5}
          exact
          path="/notfound"
          component={() => <NotFound user={user} />}
        />,
        <Route
          key={6}
          exact
          path="/error500"
          component={() => <Error500 user={user} />}
        />,
        <Route
          key={7}
          exact
          path="/maintenance"
          component={() => <Maintenance user={user} />}
        />,
      ];
      if (user.isStaff) {
        routes.push(
          <Route
            key={8}
            exact
            path="/management/dashboard"
            component={() => <ManagementDashboardQuery />}
          />,
          <Route
            key={9}
            path="/management/projects"
            component={() => (
              <ManagementProjects
                location={this.props.location}
                admin={this.props.user}
              />
            )}
          />,
          <Route
            key={10}
            path="/management/staff"
            component={() => (
              <ManagementStaff location={this.props.location} user={user} />
            )}
          />,
          <Route
            key={11}
            path="/management/absences"
            component={() => <ManagementAbsences {...this.props} />}
          />,
          <Route
            key={12}
            path="/management/basics"
            component={() => <ManagementBasics user={user} />}
          />,
          <Route
            key={13}
            path="/management/messages"
            component={() => <ManagementMessages user={user} />}
          />,
          <Route
            key={14}
            path="/management/meetings"
            component={() => <ManagementMeetings />}
          />
        );
      }
      routes.push(
        <Route
          key={15}
          exact
          path="/"
          component={() => <Redirect to={"/dashboard"} />}
        />,
        <Route key={16} exact path={"/404"} component={() => <NotFound />} />,
        <Route key={17} component={() => <Redirect to={"/404"} />} />
      );
      return (
        <BaseHorizontal user={user}>
          <React.Suspense fallback={<Loading />}>
            <Switch>{routes}</Switch>
          </React.Suspense>
        </BaseHorizontal>
      );
    } else {
      return <Redirect from={"*"} to={"/login"} />;
    }
  }
}

const RoutesFragment = createRefetchContainer(
  Routes,
  {
    user: graphql`
      fragment Routes_user on UserType
      @argumentDefinitions(
        countPending: { type: "Int", defaultValue: 6 }
        afterPending: { type: "String", defaultValue: "" }
        countAccepted: { type: "Int", defaultValue: 6 }
        afterAccepted: { type: "String", defaultValue: "" }
        countRejected: { type: "Int", defaultValue: 6 }
        afterRejected: { type: "String", defaultValue: "" }
        countCancelled: { type: "Int", defaultValue: 6 }
        afterCancelled: { type: "String", defaultValue: "" }
      ) {
        ...BaseHorizontal_user
        ...Dashboard_user
          @arguments(
            countPending: $countPending
            afterPending: $afterPending
            countAccepted: $countAccepted
            afterAccepted: $afterAccepted
            countRejected: $countRejected
            afterRejected: $afterRejected
            countCancelled: $countCancelled
            afterCancelled: $afterCancelled
          )
        ...Account_user
        ...Absences_user
          @arguments(
            countPending: $countPending
            afterPending: $afterPending
            countAccepted: $countAccepted
            afterAccepted: $afterAccepted
            countRejected: $countRejected
            afterRejected: $afterRejected
            countCancelled: $countCancelled
            afterCancelled: $afterCancelled
          )
        displayName
        isStaff
      }
    `,
  },
  graphql`
    query RoutesRefetchQuery(
      $countPending: Int
      $afterPending: String
      $countAccepted: Int
      $afterAccepted: String
      $countRejected: Int
      $afterRejected: String
      $countCancelled: Int
      $afterCancelled: String
    ) {
      user {
        ...Routes_user
          @arguments(
            countPending: $countPending
            afterPending: $afterPending
            countAccepted: $countAccepted
            afterAccepted: $afterAccepted
            countRejected: $countRejected
            afterRejected: $afterRejected
            countCancelled: $countCancelled
            afterCancelled: $afterCancelled
          )
      }
    }
  `
);

export default withRouter(RoutesFragment);



// WEBPACK FOOTER //
// ./src/Routes.js